<template>
  <myhead @next="next">{{$route.meta.title}}</myhead>
  <div class="center pad40" v-if="status">
    <div v-if="status==1">
      <div class="BGon Cfff opacity5 height50px width50px mt50 radius50 auto flex cen size32"><van-icon name="success" /></div>
      <p class="b500 mt20 mb80">您已成功支付</p>
    </div>
    <div v-if="status==2">
      <div class="BGred Cfff opacity5 height50px width50px mt50 radius50 auto flex cen size32"><van-icon name="cross" /></div>
      <p class="b500 mt20 mb80">支付失败</p>
    </div>
    <van-button type="primary" round block @click="next">返回上一页</van-button>
  </div>
  <div v-else class="mt80 center">
    <van-loading type="spinner" />
  </div>
</template>

<script>
export default {
  name: 'Status',
  data(){
    return {
      status:null
    }
  },
  methods:{
    next(){
      this.$router.push({path:'/paper'});
    },
    getDetail(){
      this.ajax.post("/pay/payresult",{no:this.$route.query.no}).then(({data})=>{
        if(data.pay_status==1){
          return this.status = 2
        }
        this.status = 1
      }).catch(()=>{
        this.status = 2
      })
    }
  },
  created(){
    setTimeout(()=>{
      this.getDetail();
    },600)  
  }
}
</script>

<style>
</style>
